import React, { useEffect, useState } from "react";

const EmailPreviewModal = ({ leadId, BASE_URL, COMPANY_CODE, DEPARTMENT }) => {
  const [emailPreviewData, setEmailPreviewData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log("Effect deps:", {
      leadId,
      BASE_URL,
      COMPANY_CODE,
      DEPARTMENT,
    });
    // Prevent execution if required data is missing
    if (!leadId || !BASE_URL || !COMPANY_CODE) return;

    const fetchEmailPreviewData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${BASE_URL}/api/MasterCount/${COMPANY_CODE}/LEADEMAILCONTENT/${leadId}/${DEPARTMENT}`,
        );
        const data = await response.json();

        // Ensure data exists before accessing index 0
        if (data && data.length > 0) {
          setEmailPreviewData(data[0].EMAILCONTENT);
        }
      } catch (error) {
        console.error("Failed to fetch email preview data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmailPreviewData();
  }, [leadId, BASE_URL, COMPANY_CODE, DEPARTMENT]);
  return (
    <div className="p-4" style={{ height: "500px" }}>
      {emailPreviewData ? (
        <div
          className="prose prose-sm max-w-none" // Optional: Tailwind Typography classes
          dangerouslySetInnerHTML={{ __html: emailPreviewData }}
        />
      ) : (
        <p>No content</p>
      )}
    </div>
  );
};

export default EmailPreviewModal;
